const footerLinks = [
  {
    title: "Servicios",
    links: [
      { label: "Revisión de facturas", href: "#servicios", external: false },
      { label: "Optimización de contratos", href: "#servicios", external: false },
      { label: "Asesoramiento personalizado", href: "#servicios", external: false },
      { label: "Autoconsumo solar", href: "#servicios", external: false },
      { label: "PPA Onsite – Solar sin inversión", href: "#servicios", external: false },
      { label: "Contador inteligente en propiedad", href: "#servicios", external: false },
      { label: "Reclamaciones ante distribuidoras", href: "#servicios", external: false },
    ],
  },
  {
    title: "Empresa",
    links: [
      { label: "Sobre nosotros", href: "#sobre-nosotros", external: false },
      { label: "Preguntas frecuentes", href: "#faq", external: false },
      { label: "Contacto", href: "#contacto", external: false },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Política de privacidad", href: "/politica-de-privacidad", external: true },
      { label: "Aviso legal", href: "/aviso-legal", external: true },
      { label: "Política de cookies", href: "/politica-de-cookies", external: true },
    ],
  },
];

export default function Footer() {
  const handleScroll = (href: string) => {
    if (href === "#") return;
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-faro-gray border-t border-faro-gray-mid">
      {/* CTA strip */}
      <div className="bg-faro-teal">
        <div className="max-w-7xl mx-auto px-6 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-white font-bold text-xl mb-1">
              ¿Listo para pagar lo justo?
            </h3>
            <p className="text-white/80 text-sm">
              Solicita tu estudio energético gratuito y sin compromiso hoy mismo.
            </p>
          </div>
          <button
            onClick={() => handleScroll("#contacto")}
            className="bg-faro-yellow hover:bg-faro-yellow-light text-faro-navy font-semibold text-sm px-8 py-3 rounded-md transition-all duration-200 cursor-pointer whitespace-nowrap flex-shrink-0"
          >
            Solicitar estudio gratuito
          </button>
        </div>
      </div>

      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img
              src="https://public.readdy.ai/ai/img_res/73dfd2d3-6ecc-4d20-afd5-49901dbfd111.png"
              alt="Faro Energía"
              className="h-16 w-auto object-contain mb-4"
            />
            <p className="text-faro-gray-text text-sm leading-relaxed max-w-xs mb-4">
              Consultoría energética independiente para particulares, pymes y comunidades de Castellón de la Plana y Barcelona. Te ayudamos a entender tu energía, optimizar tus contratos y reducir tus costes.
            </p>
            <div className="flex flex-col gap-2.5 mb-5">
              <a
                href="tel:+34657891882"
                className="inline-flex items-center gap-2 text-faro-navy hover:text-faro-teal text-sm font-medium transition-colors duration-200 cursor-pointer"
              >
                <span className="w-7 h-7 flex items-center justify-center bg-faro-teal/10 rounded-lg">
                  <i className="ri-phone-line text-faro-teal text-sm" />
                </span>
                657 891 882
              </a>
              <a
                href="mailto:hola@faroenergia.es"
                className="inline-flex items-center gap-2 text-faro-navy hover:text-faro-teal text-sm font-medium transition-colors duration-200 cursor-pointer"
              >
                <span className="w-7 h-7 flex items-center justify-center bg-faro-teal/10 rounded-lg">
                  <i className="ri-mail-line text-faro-teal text-sm" />
                </span>
                hola@faroenergia.es
              </a>
            </div>

            <div className="flex items-center gap-3">
              {["ri-linkedin-box-fill", "ri-instagram-line", "ri-twitter-x-line"].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  rel="nofollow"
                  className="w-8 h-8 flex items-center justify-center bg-faro-gray-mid hover:bg-faro-teal-pale text-faro-gray-text hover:text-faro-teal rounded-lg transition-all duration-200"
                >
                  <i className={`${icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          {footerLinks.map((col) => (
            <div key={col.title}>
              <h4 className="text-faro-navy font-semibold text-sm mb-4">
                <a href="#">{col.title}</a>
              </h4>
              <ul className="flex flex-col gap-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    {link.external ? (
                      <a
                        href={link.href}
                        className="text-faro-gray-text hover:text-faro-teal text-sm transition-colors duration-200 cursor-pointer"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <button
                        onClick={() => handleScroll(link.href)}
                        className="text-faro-gray-text hover:text-faro-teal text-sm transition-colors duration-200 cursor-pointer text-left"
                      >
                        {link.label}
                      </button>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-faro-gray-mid">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-faro-gray-text text-xs">
            &copy; {new Date().getFullYear()} Faro Energía · faroenergia.es · Todos los derechos reservados
          </p>
          <p className="text-faro-gray-text text-xs">
            Consultoría energética independiente &middot; Castellón de la Plana
          </p>
        </div>
      </div>
    </footer>
  );
}
